import { get, post } from 'common/utils/request';
export var fetchLastPolicyUpdateDateApi = function (locale) {
    return get("/compliance-documents/last-policy-update-date?Culture=".concat(locale), {}, { abortRequestKey: 'lastPolicyUpdateDateFetch' });
};
export var agreeWithPolicesApi = function () {
    return post('/compliance-documents/agree-with-policies');
};
